import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { lazy, Suspense } from 'react';

// Original homepage with full design
import Home from "./pages/Home";

// Lazy load other pages for performance
const ServiceDetail = lazy(() => import("./pages/ServiceDetail"));
const IndustryPage = lazy(() => import("./pages/IndustryPage"));
const Results = lazy(() => import("./pages/Results"));
const Story = lazy(() => import("./pages/Story"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const TermsOfService = lazy(() => import("./pages/TermsOfService"));
const CookiePolicy = lazy(() => import("./pages/CookiePolicy"));
const ProposalView = lazy(() => import("./pages/ProposalView"));
const AdminProposals = lazy(() => import("./pages/AdminProposals"));

// AI Marketing page - eager load for press release
import AIDigitalMarketingAgency from "./pages/AIDigitalMarketingAgency";

import { Toaster } from "./components/ui/sonner";
import ScrollToTop from "./components/ScrollToTop";

// Minimal loading fallback
const PageLoader = () => (
  <div className="min-h-screen bg-void flex items-center justify-center">
    <div className="w-8 h-8 border-2 border-brand border-t-transparent rounded-full animate-spin" />
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/ai-digital-marketing-agency" element={<AIDigitalMarketingAgency />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/industries/:slug" element={<IndustryPage />} />
              <Route path="/results" element={<Results />} />
              <Route path="/story" element={<Story />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route path="/proposals/admin" element={<AdminProposals />} />
              <Route path="/proposals/:slug" element={<ProposalView />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
        <Toaster />
      </div>
    </HelmetProvider>
  );
}

export default App;
